import { render } from "./PhotosEveryone.vue?vue&type=template&id=87ee785c"
import script from "./PhotosEveryone.vue?vue&type=script&lang=js"
export * from "./PhotosEveryone.vue?vue&type=script&lang=js"

import "./PhotosEveryone.vue?vue&type=style&index=0&id=87ee785c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__